import { createSlice } from "@reduxjs/toolkit";
import { experts } from "../experts";
import { getRandomInt } from "../../../util"

const oracularMessage = (text) => {
  return { text: text, sender: "oracular" };
};

const userMessage = (text) => {
  return { text: text, sender: "user" };
};

const initialState = {
  messages: [],
  oracular: experts[getRandomInt(0, experts.length - 1)],
  waitingResponse: false,
  isOracularTyping: false,
  name: null,
  zodiacSign: null
};

const persistedState = localStorage.getItem("reduxState")
  ? JSON.parse(localStorage.getItem("reduxState"))
  : initialState;

export const stateSlice = createSlice({
  name: "tarot-chat",
  initialState: persistedState,
  reducers: {
    addMessage: (state, action) => {
      state.messages = [...state.messages, userMessage(action.payload)];
    },
    addResponse: (state, action) => {
      state.messages = [...state.messages, oracularMessage(action.payload)];
    },
    setWaitingResponse: (state, action) => {
      state.waitingResponse = true;
    },
    clearWaitingResponse: (state, action) => {
      state.waitingResponse = false;
    },
    setOraculIsTyping: (state, action) => {
      state.isOracularTyping = true;
    },
    clearOraculIsTyping: (state, action) => {
      state.isOracularTyping = false;
    },
    setName: (state, action) => {
      state.name = action.payload;
    },
    setZodiacSign: (state, action) => {
      state.zodiacSign = action.payload;
    },
  },
});

export const {
  addMessage,
  addResponse,
  setWaitingResponse,
  clearWaitingResponse,
  setOraculIsTyping,
  clearOraculIsTyping,
  setName,
  setZodiacSign
} = stateSlice.actions;

export default stateSlice.reducer;
